import { render, staticRenderFns } from "./ImageMagnifier.vue?vue&type=template&id=b4fea3fa&"
import script from "./ImageMagnifier.vue?vue&type=script&lang=js&"
export * from "./ImageMagnifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports